import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import NumberFormat from 'react-number-format';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import ActionButton from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import InputTextComponent from '../components/inputs/InputTextComponent';
import OrderDetailsDialogModel from '../model/OrderDetailsDialogModel';

class OrderDetailsDialog extends BaseDialogContainer {
    constructor(props) {
        super(props);
        this.state = {
            element: new OrderDetailsDialogModel(),
            viewMode: 'VIEW',
        };
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton label={t('details.close')} variant={'button cancel-button blue'} handleClick={this.props.onHide} />
            </div>
        );
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                    <label>{`${t('order-fuel.detailsHeader')} ${
                        this.state.element.documentNumber ? this.state.element.documentNumber : ''
                    }`}</label>
                </DivContainer>
            </DivContainer>
        );
    }

    updateElement(data) {
        const {t} = this.props;
        this.setState(
            {
                element: OrderDetailsDialogModel.copy(data, t),
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }

    setElement() {
        this.updateElement(this.props.element);
    }

    renderDetails() {
        const {t} = this.props;

        return this.state.viewMode === 'EDIT' ? null : (
            <React.Fragment>
                {this.state.element.fuels && this.state.element.fuels.length
                    ? this.state.element.fuels.map((fuel, index) => {
                          return (
                              <DivContainer key={`fuel-${index}-${fuel.name}`} colClass='row'>
                                  <InputTextComponent
                                      id={`fuel-name-${index}`}
                                      name='name'
                                      label={t('order-fuel.ware')}
                                      colClass='col-md-4 col-sm-12'
                                      value={fuel.name}
                                      viewMode={'VIEW'}
                                      validator={this.validator}
                                      validators='not_required'
                                  />
                                  <InputTextComponent
                                      id={`fuel-quantity-${index}`}
                                      name='quantityAll'
                                      label={t('order-fuel.quantityAll')}
                                      colClass='col-md-4 col-sm-12'
                                      value={fuel.quantity}
                                      renderValue={() => {
                                          return fuel ? (
                                              <React.Fragment>
                                                  <span>
                                                      {fuel.quantity} m<sup>3</sup> ({fuel.volume} l)
                                                  </span>
                                              </React.Fragment>
                                          ) : (
                                              <label />
                                          );
                                      }}
                                      viewMode={'VIEW'}
                                      validator={this.validator}
                                      validators='not_required'
                                  />
                                  <InputTextComponent
                                      id={`fuel-quantity-${index}`}
                                      name='value'
                                      label={t('order-fuel.valueLabel')}
                                      colClass='col-md-4 col-sm-12'
                                      value={fuel.value}
                                      renderValue={() => {
                                          return fuel ? (
                                              <NumberFormat
                                                  value={fuel.value}
                                                  displayType={'text'}
                                                  thousandSeparator=' '
                                                  decimalSeparator=','
                                                  fixedDecimalScale
                                                  decimalScale={2}
                                                  suffix={` ${t('currency.pln')}`}
                                                  renderText={(value, props) => value}
                                              />
                                          ) : (
                                              <label />
                                          );
                                      }}
                                      viewMode={'VIEW'}
                                      validator={this.validator}
                                      validators='not_required'
                                  />
                              </DivContainer>
                          );
                      })
                    : null}
                <DivContainer colClass='row'>
                    <InputTextComponent
                        id='werks'
                        name='werks'
                        label={t('order-fuel.werks')}
                        colClass='col-12'
                        value={this.state.element?.werksDesc}
                        viewMode={'VIEW'}
                        validator={this.validator}
                        validators='not_required'
                        rendered={!!this.state.element?.werksDesc}
                    />
                    <InputTextComponent
                        id='partner'
                        name='partner'
                        label={t('order-fuel.partner')}
                        colClass='col-12'
                        value={this.state.element?.deliveryPlace}
                        viewMode={'VIEW'}
                        validator={this.validator}
                        validators='not_required'
                        rendered={!!this.state.element?.deliveryPlace}
                    />
                    <InputTextComponent
                        id='driver'
                        name='driver'
                        label={t('order-fuel.driver')}
                        colClass='col-md-4 col-sm-12'
                        value={this.state.element.driverName}
                        viewMode={'VIEW'}
                        validator={this.validator}
                        validators='not_required'
                        rendered={!!this.state.element?.driverName}
                    />
                    <InputTextComponent
                        id='vehicle'
                        name='vehicle'
                        label={t('order-fuel.vehicle')}
                        colClass='col-md-4 col-sm-12'
                        value={this.state.element.vehicleRegistrationNumber}
                        viewMode={'VIEW'}
                        validator={this.validator}
                        validators='not_required'
                        rendered={!!this.state.element?.vehicleRegistrationNumber}
                    />
                    <InputTextComponent
                        id='trailer'
                        name='trailer'
                        label={t('order-fuel.trailer')}
                        colClass='col-md-4 col-sm-12'
                        value={this.state.element.trailerRegistrationNumber}
                        viewMode={'VIEW'}
                        validator={this.validator}
                        validators='not_required'
                        rendered={!!this.state.element?.trailerRegistrationNumber}
                    />
                </DivContainer>
            </React.Fragment>
        );
    }
}

OrderDetailsDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    visible: false,
};

OrderDetailsDialog.propTypes = {
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    elementId: PropTypes.number,
    element: PropTypes.object,
};

export default withTranslation()(OrderDetailsDialog);
